<template>

</template>
<!--地球页面Globe混入方法：影像中心我的文件相关-->
<script>
import * as turf from '@turf/turf'

export default {
  name: "GlobeMyFolder",
  data() {
    return {
      initCenter: [90.94487491007658, 39.86471240059555],
      initZoom: 3,
      markerList_xzt: {
        'type': 'FeatureCollection',
        'features': []
      },
      //线集合
      lineJson_xzt: {
        linePoint: {
          'type': 'FeatureCollection',
          'features': []
        },
        lineGeo: {
          "type": "FeatureCollection",
          "features": []
        },
        lineNamePoint: {
          'type': 'FeatureCollection',
          'features': []
        }
      },
      //路线集合
      roadJson_xzt: {
        roadPoint: {
          'type': 'FeatureCollection',
          'features': []
        },
        roadGeo: {
          "type": "FeatureCollection",
          "features": []
        },
        roadNamePoint: {
          'type': 'FeatureCollection',
          'features': []
        }
      },
      //四边形集合
      polygonJson_xzt: {
        polygonPoint: {
          'type': 'FeatureCollection',
          'features': []
        },
        polygonGeo: {
          "type": "FeatureCollection",
          "features": []
        },
        polygonNamePoint: {
          "type": "FeatureCollection",
          "features": []
        },
        polygonLenPoint: {
          "type": "FeatureCollection",
          "features": []
        },
        circleRadiusPoint: {
          "type": "FeatureCollection",
          "features": []
        }
      },
      measureLengthJson_xzt:{
        measurePoint:{
          'type': 'FeatureCollection',
          'features': []
        },
        measureGeo:{
          "type": "FeatureCollection",
          "features": []
        },
        measureNamePoint:{
          "type": "FeatureCollection",
          "features": []
        },
        measureStartAndEndPoint:{
          "type": "FeatureCollection",
          "features": []
        }
      },
      measureAreaJson_xzt:{
        measurePoint:{
          'type': 'FeatureCollection',
          'features': []
        },
        measureGeo:{
          "type": "FeatureCollection",
          "features": []
        },
        measureNamePoint:{
          "type": "FeatureCollection",
          "features": []
        }
      },
    }
  },
  methods: {
    flyToFolderFirstMarker(geo, type) {
      const bbox = turf.bbox(geo)
      if (type === 'point') {
        this.map.flyTo({
          center: [geo['geometry']['coordinates'][0], geo['geometry']['coordinates'][1]],
          zoom: 15
        })
      } else {
        this.map.fitBounds([[bbox[0], bbox[1]], [bbox[2], bbox[3]]],{
          linear: false,
          animate: true,
          padding: {top: 0, bottom:0, left: 0, right: 0},
        })
      }
    },
    flyToOriginalPositionAndClearLayers() {
      this.map.flyTo({
        center: this.initCenter,
        zoom: this.initZoom,
        bearing: 0,
        pitch: 0
      })
    },
    deleteOpenFile() {
      // 关闭了在创作中已经打开的文件
      this.$store.state.currFolderId = ''
      this.$store.state.currFolderName = ''
      this.$store.state.currFolderPublicStatus = '未公开'
      this.$store.state.globeOperationMarkerList = ''
      this.$store.state.globeOperationLayerList = ''
      // 删除图层
      this.map.getSource('markerLayer').setData({'type': 'FeatureCollection', 'features': []})
      this.map.getSource('lineLayer').setData({'type': 'FeatureCollection', 'features': []});
      this.map.getSource('linePointLayer').setData({'type': 'FeatureCollection', 'features': []});
      this.map.getSource('lineNamePoint').setData({'type': 'FeatureCollection', 'features': []})
      this.map.getSource('roadNamePoint').setData({'type': 'FeatureCollection', 'features': []})
      this.map.getSource('roadPointLayer').setData({'type': 'FeatureCollection', 'features': []})
      this.map.getSource('roadLayer').setData({'type': 'FeatureCollection', 'features': []})
      this.map.getSource('polygonLayer').setData({'type': 'FeatureCollection', 'features': []});
      this.map.getSource('circleRadiusPoint').setData({'type': 'FeatureCollection', 'features': []});
      this.map.getSource('polygonNameLayer').setData({'type': 'FeatureCollection', 'features': []});
      this.map.getSource('polygonLenLayer').setData({'type': 'FeatureCollection', 'features': []});
      this.map.getSource('polygonPointLayer').setData({'type': 'FeatureCollection', 'features': []});
    },
    clearPrevData() {
      this.markerList_xzt.features = []
      this.lineJson_xzt.linePoint.features = []
      this.lineJson_xzt.lineGeo.features = []
      this.lineJson_xzt.lineNamePoint.features = []
      this.roadJson_xzt.roadPoint.features = []
      this.roadJson_xzt.roadGeo.features = []
      this.roadJson_xzt.roadNamePoint.features = []
      this.polygonJson_xzt.polygonPoint.features = []
      this.polygonJson_xzt.polygonGeo.features = []
      this.polygonJson_xzt.polygonNamePoint.features = []
      this.polygonJson_xzt.polygonLenPoint.features = []
      this.polygonJson_xzt.circleRadiusPoint.features = []
      this.measureAreaJson_xzt.measureGeo.features = []
      this.measureAreaJson_xzt.measurePoint.features = []
      this.measureAreaJson_xzt.measureNamePoint.features = []
      this.measureLengthJson_xzt.measureGeo.features = []
      this.measureLengthJson_xzt.measurePoint.features = []
      this.measureLengthJson_xzt.measureNamePoint.features = []
      this.measureLengthJson_xzt.measureStartAndEndPoint.features = []
      this.map.getSource('markerLayer_xzt').setData(this.markerList_xzt)
      this.map.getSource('lineLayer_xzt').setData(this.lineJson_xzt.lineGeo);
      this.map.getSource('lineNamePoint_xzt').setData(this.lineJson_xzt.lineNamePoint)
      this.map.getSource('linePointLayer_xzt').setData(this.lineJson_xzt.linePoint);
      this.map.getSource('roadLayer_xzt').setData(this.roadJson_xzt.roadGeo)
      this.map.getSource('roadNamePoint_xzt').setData(this.roadJson_xzt.roadNamePoint)
      this.map.getSource('roadPointLayer_xzt').setData(this.roadJson_xzt.roadPoint)
      this.map.getSource('polygonLayer_xzt').setData(this.polygonJson_xzt.polygonGeo);
      this.map.getSource('circleRadiusPoint_xzt').setData(this.polygonJson_xzt.circleRadiusPoint);
      this.map.getSource('polygonNameLayer_xzt').setData(this.polygonJson_xzt.polygonNamePoint);
      this.map.getSource('polygonLayer_xzt').setData(this.polygonJson_xzt.polygonGeo);
      this.map.getSource('polygonNameLayer_xzt').setData(this.polygonJson_xzt.polygonNamePoint);
      this.map.getSource('polygonPointLayer_xzt').setData(this.polygonJson_xzt.polygonPoint);
      this.map.getSource('polygonLenLayer_xzt').setData(this.polygonJson_xzt.polygonLenPoint);
      this.map.getSource('polygonLayer_xzt').setData(this.polygonJson_xzt.polygonGeo);
      this.map.getSource('polygonNameLayer_xzt').setData(this.polygonJson_xzt.polygonNamePoint);
      this.map.getSource('polygonPointLayer_xzt').setData(this.polygonJson_xzt.polygonPoint);
      this.map.getSource('polygonLayer_xzt').setData(this.polygonJson_xzt.polygonGeo);
      this.map.getSource('polygonNameLayer_xzt').setData(this.polygonJson_xzt.polygonNamePoint);
      this.showXztLayers()
    },
    showXztLayers() {
      let layersXzt = ['markerList2_xzt','lineNamePoint_xzt','linePointLayer_xzt','linePointSymbol_xzt','lineLayer_xzt','roadNamePoint_xzt','roadPointLayer_xzt','roadPointSymbol_xzt','roadLayer_xzt','circleRadiusPoint_xzt','polygonNameLayer_xzt','polygonPointLayer_xzt','polygonPointSymbol_xzt','polygonLenLayer_xzt','polygonLineLayer_xzt','polygonLayer_xzt','measurePoints_xzt','measureLine_xzt','measureLineName_xzt','measureAreaLayer_xzt','measureAreaLineLayer_xzt','measureAreaPointLayer_xzt','measureAreaNameLayer_xzt']
      layersXzt.forEach((layerName) => {
        this.map.setLayoutProperty(layerName, 'visibility','visible')
      })
    },
    openFolderById_xzt(folderId) {
      //清除掉选择的图层
      this.getFolderDataList_xzt(folderId)
      this.getFolderLayerList_xzt(folderId)
    },
    getFolderDataList_xzt(folderId) {
      this.$axios.get('/authorApi/z-geo-file/openFile', {
        params: {
          'fileId': folderId
        }
      }).then((resultData) => {
        resultData = resultData.data;
        if (resultData.status === 200) {
          this.initMapMarker_xzt(resultData.data.content)
        } else {
          console.log(resultData.status + resultData.message);
        }
      }).catch(() => {
      })
    },
    getFolderLayerList_xzt(folderId) {
      this.$axios.get('/authorApi/z-geo-file/openFileLayer', {
        params: {
          'fileId': folderId
        }
      }).then((resultData) => {
        resultData = resultData.data;
        if (resultData.status === 200) {
        } else {
          console.log(resultData.status + resultData.message);
        }
      }).catch(() => {
      })
    },
    globeMarkerFun_xzt(){
      //加载地图上的点
      this.map.addSource('markerLayer_xzt',{
        type:"geojson",
        data:this.markerList_xzt
      })
      //加载地图上的线
      this.map.addSource('linePointLayer_xzt',{
        type:"geojson",
        data:this.lineJson_xzt.linePoint
      })
      this.map.addSource('lineLayer_xzt',{
        type:"geojson",
        data:this.lineJson_xzt.lineGeo
      })
      this.map.addSource('lineNamePoint_xzt',{
        type:"geojson",
        data:this.lineJson_xzt.lineNamePoint
      })
      //加载地图上的多边形
      this.map.addSource('polygonLayer_xzt',{
        type:"geojson",
        data:this.polygonJson_xzt.polygonGeo
      })
      this.map.addSource('polygonPointLayer_xzt',{
        type:"geojson",
        data:this.polygonJson_xzt.polygonPoint
      })
      this.map.addSource('polygonNameLayer_xzt',{
        type:"geojson",
        data:this.polygonJson_xzt.polygonNamePoint
      })
      this.map.addSource('polygonLenLayer_xzt',{
        type:"geojson",
        data:this.polygonJson_xzt.polygonLenPoint
      })
      this.map.addSource('circleRadiusPoint_xzt',{
        type:"geojson",
        data:this.polygonJson_xzt.polygonLenPoint
      })
      this.map.addSource('roadPointLayer_xzt',{
        type:"geojson",
        data:this.roadJson_xzt.roadPoint
      })
      this.map.addSource('roadLayer_xzt',{
        type:"geojson",
        data:this.roadJson_xzt.roadGeo
      })
      this.map.addSource('roadNamePoint_xzt',{
        type:"geojson",
        data:this.roadJson_xzt.roadNamePoint
      })
      //测量数据
      this.map.addSource('measurePoints_xzt', {
        type: 'geojson',
        data: this.measureLengthJson_xzt.measurePoint
      });
      this.map.addSource('measureLine_xzt', {
        type: 'geojson',
        data: this.measureLengthJson_xzt.measureGeo
      });
      this.map.addSource('measureLineName_xzt',{
        type: 'geojson',
        data: this.measureLengthJson_xzt.measureNamePoint
      })
      this.map.addSource('measureAreaLayer_xzt',{
        type:"geojson",
        data:this.measureAreaJson_xzt.measureGeo
      })
      this.map.addSource('measureAreaPointLayer_xzt',{
        type:"geojson",
        data:this.measureAreaJson_xzt.measurePoint
      })
      this.map.addSource('measureAreaNameLayer_xzt',{
        type:"geojson",
        data:this.measureAreaJson_xzt.measureNamePoint
      })
      this.map.addLayer({
        "id": "markerList2_xzt",
        "type": "symbol",
        "source": "markerLayer_xzt",
        "layout":{
          "icon-size":['get', 'size'],
          "icon-anchor":"bottom",
          "icon-image":[
            'match',
            ["concat", ['get', 'code'],['get', 'color']],

            '&#xe6b6;#FF0000','marker_one_red1',
            '&#xe6b6;#FFC800','marker_one_yellow1',
            '&#xe6b6;#2A82E4','marker_one_blue1',
            '&#xe6b6;#00FF00','marker_one_green1',
            '&#xe6b6;#00FFFF','marker_one_cyan1',

            '&#xe657;#FF0000','marker_two_red1',
            '&#xe657;#FFC800','marker_two_yellow1',
            '&#xe657;#2A82E4','marker_two_blue1',
            '&#xe657;#00FF00','marker_two_green1',
            '&#xe657;#00FFFF','marker_two_cyan1',

            '&#xe653;#FF0000','marker_three_red1',
            '&#xe653;#FFC800','marker_three_yellow1',
            '&#xe653;#2A82E4','marker_three_blue1',
            '&#xe653;#00FF00','marker_three_green1',
            '&#xe653;#00FFFF','marker_three_cyan1',

            '&#xe65a;#FF0000','marker_four_red1',
            '&#xe65a;#FFC800','marker_four_yellow1',
            '&#xe65a;#2A82E4','marker_four_blue1',
            '&#xe65a;#00FF00','marker_four_green1',
            '&#xe65a;#00FFFF','marker_four_cyan1',

            '&#xe63c;#FF0000','marker_five_red1',
            '&#xe63c;#FFC800','marker_five_yellow1',
            '&#xe63c;#2A82E4','marker_five_blue1',
            '&#xe63c;#00FF00','marker_five_green1',
            '&#xe63c;#00FFFF','marker_five_cyan1',

            '&#xe651;#FF0000','marker_six_red1',
            '&#xe651;#FFC800','marker_six_yellow1',
            '&#xe651;#2A82E4','marker_six_blue1',
            '&#xe651;#00FF00','marker_six_green1',
            '&#xe651;#00FFFF','marker_six_cyan1',

            '&#xe664;#FF0000','marker_seven_red1',
            '&#xe664;#FFC800','marker_seven_yellow1',
            '&#xe664;#2A82E4','marker_seven_blue1',
            '&#xe664;#00FF00','marker_seven_green1',
            '&#xe664;#00FFFF','marker_seven_cyan1',

            '&#xe654;#FF0000','marker_eight_red1',
            '&#xe654;#FFC800','marker_eight_yellow1',
            '&#xe654;#2A82E4','marker_eight_blue1',
            '&#xe654;#00FF00','marker_eight_green1',
            '&#xe654;#00FFFF','marker_eight_cyan1',

            '&#xe656;#FF0000','marker_nine_red1',
            '&#xe656;#FFC800','marker_nine_yellow1',
            '&#xe656;#2A82E4','marker_nine_blue1',
            '&#xe656;#00FF00','marker_nine_green1',
            '&#xe656;#00FFFF','marker_nine_cyan1',

            'marker_one_blue1'
          ],
          "text-font":this.$store.state.font,
          "text-field": ["get", "name"],
          "text-size":16,
          "text-anchor": "bottom",
          // "text-offset": [0, -2.3],
          "text-offset":[ 'interpolate',
            ["linear"],
            ['get', 'size'],
            0.5,
            ["literal", [0, -2.5]],
            0.7,
            ["literal", [0, -5]],
            0.9,
            ["literal", [0, -5]],
            1.1,
            ["literal", [0, -7.4]],
          ],
          "icon-allow-overlap":true,
          "text-allow-overlap":true,
          "visibility":'visible',
        },
        // "filter":['==','visible','visible'],
        "paint":{
          "text-color": "#ffffff",
          "text-halo-color":'rgba(0, 0, 0, 1)',
          "text-halo-blur":3,
          "text-halo-width": 1,
          "icon-opacity": 1,
          //"icon-color":["get", "color"],
          // "icon-halo-color":'rgba(0, 0, 0, 1)',
          // "icon-halo-blur":2,
          // "icon-halo-width":1.5,
        }
      },)//点
      this.map.addLayer({
        id:'lineNamePoint_xzt',
        type:'symbol',
        source: 'lineNamePoint_xzt',
        layout:{
          "text-field": ["get", "name"],
          "text-font":this.$store.state.font,
          "text-size":16,
          "text-anchor": "top",
          "text-offset": [-1.3,1],
          "visibility":'visible',
          "icon-allow-overlap":true,
          "text-allow-overlap":true,
        },
        // filter:['==','visible','visible'],
        paint:{
          "text-color": "#ffffff",
          "text-halo-color":'rgba(0, 0, 0, 1)',
          "text-halo-blur":3,
          "text-halo-width": 1,
        }
      },'markerList2_xzt')//线名
      this.map.addLayer({
        id: 'linePointLayer_xzt',
        type: 'circle',
        source: 'linePointLayer_xzt',
        layout:{
          "visibility":'visible',
        },
        // filter:['==','visible','visible'],
        paint: {
          'circle-color': ["get", "color"],
          'circle-radius': 5,
          'circle-stroke-width': 3,
          'circle-stroke-color': '#ffffff'
        }
      },'lineNamePoint_xzt');//线-点
      this.map.addLayer({
        id:'linePointSymbol_xzt',
        type:'symbol',
        source: 'linePointLayer_xzt',
        layout:{
          "text-field": ["get", "name"],
          "text-font":this.$store.state.font,
          "text-size":16,
          "text-anchor": "bottom",
          "text-offset": [0,-0.8],
          "visibility":'visible',
          "icon-allow-overlap":true,
          "text-allow-overlap":true,
        },
        // filter:['==','visible','visible'],
        paint:{
          "text-color": "#ffffff",
          "text-halo-color":'rgba(0, 0, 0, 1)',
          "text-halo-blur":3,
          "text-halo-width": 1,
        }
      },'linePointLayer_xzt')//点名
      this.map.addLayer({
        id: 'lineLayer_xzt',
        type: 'line',
        source: 'lineLayer_xzt',
        layout:{
          "visibility":'visible',
        },
        // filter:['==','visible','visible'],
        paint: {
          'line-color': ["get", "color"],
          'line-width':["get", "width"],
          'line-opacity': 1,
          // 'line-blur':5,
        }
      },'linePointSymbol_xzt')//线
      //加载地图上路线规划
      this.map.addLayer({
        id:'roadNamePoint_xzt',
        type:'symbol',
        source: 'roadNamePoint_xzt',
        layout:{
          "text-field": ["get", "name"],
          "text-font":this.$store.state.font,
          "text-size":16,
          "text-anchor": "top",
          "text-offset": [-1.3,1],
          "visibility":'visible',
        },
        // filter:['==','visible','visible'],
        paint:{
          "text-color": "#ffffff",
          "text-halo-color":'rgba(0, 0, 0, 1)',
          "text-halo-blur":3,
          "text-halo-width": 1,
        }
      },'lineLayer_xzt')
      this.map.addLayer({
        id: 'roadPointLayer_xzt',
        type: 'circle',
        source: 'roadPointLayer_xzt',
        layout:{
          "visibility":'visible',
        },
        // filter:['==','visible','visible'],
        paint: {
          'circle-color':["get", "color"],
          'circle-radius': 5,
          'circle-stroke-width': 3,
          'circle-stroke-color': '#ffffff'
        }
      },'roadNamePoint_xzt');
      this.map.addLayer({
        id:'roadPointSymbol_xzt',
        type:'symbol',
        source: 'roadPointLayer_xzt',
        layout:{
          "text-field": ["get", "name"],
          "text-font":this.$store.state.font,
          "text-size":16,
          "text-anchor": "bottom",
          "text-offset": [0,-0.8],
          "visibility":'visible',
        },
        // filter:['==','visible','visible'],
        paint:{
          "text-color": "#ffffff",
          "text-halo-color":'rgba(0, 0, 0, 1)',
          "text-halo-blur":3,
          "text-halo-width": 1,
        }
      },'roadPointLayer_xzt')
      this.map.addLayer({
        id: 'roadLayer_xzt',
        type: 'line',
        source: 'roadLayer_xzt',
        layout:{
          "visibility":'visible',
        },
        // filter:['==','visible','visible'],
        paint: {
          'line-color': ["get", "color"],
          'line-width':["get", "width"],
          'line-opacity': 1
        }
      },'roadPointSymbol_xzt')
      this.map.addLayer({
        id:'circleRadiusPoint_xzt',
        type:'symbol',
        source: 'circleRadiusPoint_xzt',
        layout:{
          "text-field": ["get", "name"],
          "text-font":this.$store.state.font,
          "text-size":16,
          "text-anchor": "left",
          "text-offset": [1,0],
          "text-line-height":2,
          "visibility":'visible',
        },
        // filter:['==','visible','visible'],
        paint:{
          "text-color": "#ffffff",
          "text-halo-color":'rgba(0, 0, 0, 1)',
          "text-halo-blur":3,
          "text-halo-width": 1,
        }
      },'roadLayer_xzt')//圆半径
      this.map.addLayer({
        id:'polygonNameLayer_xzt',
        type:'symbol',
        source: 'polygonNameLayer_xzt',
        layout:{
          "text-field": ["get", "name"],
          "text-font":this.$store.state.font,
          "text-size":16,
          "text-anchor": "center",
          "visibility":'visible',
        },
        // filter:['==','visible','visible'],
        paint:{
          "text-color": "#ffffff",
          "text-halo-color":'rgba(0, 0, 0, 1)',
          "text-halo-blur":3,
          "text-halo-width": 1,
        }
      },'circleRadiusPoint_xzt')//名字
      this.map.addLayer({
        id: 'polygonPointLayer_xzt',
        type: 'circle',
        source: 'polygonPointLayer_xzt',
        layout: {
          "visibility":'visible',
        },
        // filter:['==','visible','visible'],
        paint: {
          'circle-color': ["get", "color"],
          'circle-radius': 5,
          'circle-stroke-width': 3,
          'circle-stroke-color': '#ffffff'
        }
      },'polygonNameLayer_xzt')//点
      this.map.addLayer({
        id:'polygonPointSymbol_xzt',
        type:'symbol',
        source: 'polygonPointLayer_xzt',
        layout:{
          "text-field": ["get", "name"],
          "text-font":this.$store.state.font,
          "text-size":16,
          "text-anchor": "bottom",
          "text-offset": [0,-0.8],
          "visibility":'visible',
        },
        // filter:['==','visible','visible'],
        paint:{
          "text-color": "#ffffff",
          "text-halo-color":'rgba(0, 0, 0, 1)',
          "text-halo-blur":3,
          "text-halo-width": 1,
        }
      },'polygonPointLayer_xzt')//点名
      this.map.addLayer({
        id:'polygonLenLayer_xzt',
        type:'symbol',
        source: 'polygonLenLayer_xzt',
        layout:{
          "text-field": ["get", "name"],
          "text-font":this.$store.state.font,
          "text-size":16,
          "text-anchor": "center",
          "visibility":'visible',
        },
        // filter:['==','visible','visible'],
        paint:{
          "text-color": "#ffffff",
          "text-halo-color":'rgba(0, 0, 0, 1)',
          "text-halo-blur":3,
          "text-halo-width": 1,
        }
      },'polygonPointSymbol_xzt')//线名
      this.map.addLayer({
        id: 'polygonLineLayer_xzt',
        type: 'line',
        source: 'polygonLayer_xzt',
        layout: {
          "visibility":'visible',
        },
        // filter:['==','visible','visible'],
        paint: {
          'line-color': ["get", "lineColor"],
          'line-width': ["get", "width"]
        }
      },'polygonLenLayer_xzt')//线
      this.map.addLayer({
        id: 'polygonLayer_xzt',
        type: 'fill',
        source: 'polygonLayer_xzt',
        layout: {
          "visibility":'visible',
        },
        // filter:['==','visible','visible'],
        paint: {
          'fill-color':["get", "color"],
          'fill-opacity': 0.5,
        }
      },'polygonLineLayer_xzt')//多边形
      this.map.addLayer({
        id: 'measurePoints_xzt',
        type: 'circle',
        source: 'measurePoints_xzt',
        paint: {
          'circle-color': '#00BAAD',
          'circle-radius': 5,
          'circle-stroke-width': 2,
          'circle-stroke-color': '#ffffff'
        }
      });
      this.map.addLayer({
        id: 'measureLine_xzt',
        type: 'line',
        source: 'measureLine_xzt',
        paint: {
          'line-color': '#00BAAD',
          'line-width': 2,
          'line-opacity': 1
        }
      });
      this.map.addLayer({
        id: 'measureLineName_xzt',
        type: 'symbol',
        source: 'measureLineName_xzt',
        layout:{
          "text-field": ["get", "name"],
          "text-font":this.$store.state.font,
          "text-size":14,
          "text-anchor": "center",
        },
        paint:{
          "text-color": "#ffffff",
          "text-halo-color":'rgba(0, 0, 0, 1)',
          "text-halo-blur":1,
          "text-halo-width": 2,
        }
      })
      this.map.addLayer({
        id: 'measureAreaLayer_xzt',
        type: 'fill',
        source: 'measureAreaLayer_xzt',
        layout: {},
        paint: {
          'fill-color':"#00BAAD",
          'fill-opacity': 0.5,
        }
      })
      this.map.addLayer({
        id: 'measureAreaLineLayer_xzt',
        type: 'line',
        source: 'measureAreaLayer_xzt',
        layout: {},
        paint: {
          'line-color': "#00BAAD",
          'line-width': 1
        }
      })
      this.map.addLayer({
        id: 'measureAreaPointLayer_xzt',
        type: 'circle',
        source: 'measureAreaPointLayer_xzt',
        paint: {
          'circle-color': '#00BAAD',
          'circle-radius': 5,
          'circle-stroke-width': 2,
          'circle-stroke-color': '#ffffff'
        }
      })
      this.map.addLayer({
        id: 'measureAreaNameLayer_xzt',
        type: 'symbol',
        source: 'measureAreaNameLayer_xzt',
        layout:{
          "text-field": ["get", "name"],
          "text-font":this.$store.state.font,
          "text-size":14,
          "text-anchor": "center",
        },
        paint:{
          "text-color": "#ffffff",
          "text-halo-color":'rgba(0, 0, 0, 1)',
          "text-halo-blur":1,
          "text-halo-width": 1,
        }
      })
    },
    initMapMarker_xzt(val) {
      for (let i = 0; i < val.length; i++) {
        if (val[i].type !== 'folder') {
          this.addToMap_xzt(val[i])
        }
        this.initMapMarker_xzt(val[i].children)
      }
    },
    addToMap_xzt(val) {
      let map = {
        "point": (val) => {
          this.addPointToMap_xzt(val)
        },
        "lineString": (val) => {
          this.addLinToMap_xzt(val)
        },
        "roadString": (val) => {
          this.addRoadToMap_xzt(val)
        },
        "circle": (val) => {
          this.addCircleToMap_xzt(val)
        },
        "rectangle": (val) => {
          this.addRectangleToMap_xzt(val)
        },
        "polygon": (val) => {
          this.addPolygonToMap_xzt(val)
        },
        "administrativeArea": (val) => {
          this.addAreaToMap_xzt(val)
        },
      }
      map[val.type](val)
    },
    addPointToMap_xzt(val) {
      let point = {
        type: 'Feature',
        id: val.id,
        geometry: val.geoJson.geo.geometry,
        properties: val.geoJson.geo.properties
      }
      this.markerList_xzt.features.push(point)
      this.map.getSource('markerLayer_xzt').setData(this.markerList_xzt)
    },
    addLinToMap_xzt(val) {
      let line = {
        type: 'Feature',
        id: val.id,
        geometry: val.geoJson.geo.geometry,
        properties: val.geoJson.geo.properties
      }
      this.lineJson_xzt.lineGeo.features.push(line)
      this.map.getSource('lineLayer_xzt').setData(this.lineJson_xzt.lineGeo);
      if (val.geoJson.points.length !== 0) {
        let lineName = {
          type: 'Feature',
          geometry: {
            type: 'Point',
            coordinates: val.geoJson.points[0].geometry.coordinates
          },
          id: val.id,
          properties: {
            "type": 'point',
            "name": val.geoJson.geo.properties.name,
            "visible": val.visible ? "visible" : "none",
            "country": "",
            "addrName": "",
            "imageList": [],
            "secondId": '',
          }
        }
        this.lineJson_xzt.lineNamePoint.features.push(lineName)
        this.map.getSource('lineNamePoint_xzt').setData(this.lineJson_xzt.lineNamePoint)
        this.lineJson_xzt.linePoint.features.push(...val.geoJson.points)
        this.map.getSource('linePointLayer_xzt').setData(this.lineJson_xzt.linePoint);
      }
    },
    addRoadToMap_xzt(val) {
      let line = {
        type: 'Feature',
        id: val.id,
        geometry: val.geoJson.geo.geometry,
        properties: val.geoJson.geo.properties
      }
      this.roadJson_xzt.roadGeo.features.push(line)
      this.map.getSource('roadLayer_xzt').setData(this.roadJson_xzt.roadGeo)
      if (val.geoJson.points.length !== 0) {
        let lineName = {
          type: 'Feature',
          geometry: {
            type: 'Point',
            coordinates: val.geoJson.points[0].geometry.coordinates
          },
          id: val.id,
          properties: {
            "type": 'point',
            "name": val.geoJson.geo.properties.name,
            "visible": val.visible ? "visible" : "none",
            "country": "",
            "addrName": "",
            "imageList": [],
            "secondId": '',
          }
        }
        this.roadJson_xzt.roadNamePoint.features.push(lineName)
        this.map.getSource('roadNamePoint_xzt').setData(this.roadJson_xzt.roadNamePoint)
        this.roadJson_xzt.roadPoint.features.push(...val.geoJson.points)
        this.map.getSource('roadPointLayer_xzt').setData(this.roadJson_xzt.roadPoint)
      }
    },
    addCircleToMap_xzt(val) {
      let circle = {
        type: 'Feature',
        id: val.id,
        geometry: val.geoJson.geo.geometry,
        properties: val.geoJson.geo.properties
      }
      this.polygonJson_xzt.polygonGeo.features.push(circle)
      let circleName = {
        type: 'Feature',
        geometry: {
          type: 'Point',
          coordinates: val.geoJson.geo.properties.center
        },
        id: val.id,
        properties: {
          "type": 'point',
          "name": val.geoJson.geo.properties.name,
          "visible": val.visible ? "visible" : "none",
          "country": "",
          "addrName": "",
          "imageList": [],
          "secondId": '',
        }
      }
      this.polygonJson_xzt.polygonNamePoint.features.push(circleName)
      let circleRadius = {
        type: 'Feature',
        geometry: {
          type: 'Point',
          coordinates: val.geoJson.geo.properties.center
        },
        id: val.id,
        properties: {
          "type": 'point',
          "name": "半径：" + this.lengthUomConversion(val.geoJson.geo.properties.len),
          "visible": "none",
          "country": "",
          "addrName": "",
          "imageList": [],
          "secondId": '',
        }
      }
      let translation = turf.transformTranslate(circleRadius, val.geoJson.geo.properties.len / 1000, 90)
      this.polygonJson_xzt.circleRadiusPoint.features.push(translation)
      this.map.getSource('polygonLayer_xzt').setData(this.polygonJson_xzt.polygonGeo);
      this.map.getSource('circleRadiusPoint_xzt').setData(this.polygonJson_xzt.circleRadiusPoint);
      this.map.getSource('polygonNameLayer_xzt').setData(this.polygonJson_xzt.polygonNamePoint);
    },
    addRectangleToMap_xzt(val) {
      let rectangle = {
        type: 'Feature',
        id: val.id,
        geometry: val.geoJson.geo.geometry,
        properties: val.geoJson.geo.properties
      }
      this.polygonJson_xzt.polygonGeo.features.push(rectangle)
      this.map.getSource('polygonLayer_xzt').setData(this.polygonJson_xzt.polygonGeo);
      let rectangleName = {
        type: 'Feature',
        geometry: {
          type: 'Point',
          coordinates: val.geoJson.geo.properties.center
        },
        id: val.id,
        properties: {
          "type": 'point',
          "name": val.geoJson.geo.properties.name,
          "visible": val.visible ? "visible" : "none",
          "country": "",
          "addrName": "",
          "imageList": [],
          "secondId": '',
        }
      }
      this.polygonJson_xzt.polygonNamePoint.features.push(rectangleName)
      this.map.getSource('polygonNameLayer_xzt').setData(this.polygonJson_xzt.polygonNamePoint);
      if (val.geoJson.points.length !== 0) {
        this.polygonJson_xzt.polygonPoint.features.push(...val.geoJson.points)
        this.map.getSource('polygonPointLayer_xzt').setData(this.polygonJson_xzt.polygonPoint);
      }
      let leftCenter = turf.midpoint(turf.point(val.geoJson.geo.geometry.coordinates[0][0]), turf.point(val.geoJson.geo.geometry.coordinates[0][3]))
      let leftLen = turf.distance(turf.point(val.geoJson.geo.geometry.coordinates[0][0]), turf.point(val.geoJson.geo.geometry.coordinates[0][3]), {units: 'kilometers'})
      this.polygonJson_xzt.polygonLenPoint.features.push(
          {
            type: 'Feature',
            geometry: {
              type: 'Point',
              coordinates: leftCenter.geometry.coordinates
            },
            id: val.id,
            properties: {
              "type": 'point',
              "name": this.lengthUomConversion(leftLen * 1000),
              "visible": "none",
              "country": '',
              "addrName": '',
              "imageList": [],
              "secondId": ''
            },
          }
      )
      let rightCenter = turf.midpoint(turf.point(val.geoJson.geo.geometry.coordinates[0][2]), turf.point(val.geoJson.geo.geometry.coordinates[0][3]))
      let rightLen = turf.distance(turf.point(val.geoJson.geo.geometry.coordinates[0][2]), turf.point(val.geoJson.geo.geometry.coordinates[0][3]), {units: 'kilometers'})
      this.polygonJson_xzt.polygonLenPoint.features.push(
          {
            type: 'Feature',
            geometry: {
              type: 'Point',
              coordinates: rightCenter.geometry.coordinates
            },
            id: val.id,
            properties: {
              "type": 'point',
              "name": this.lengthUomConversion(rightLen * 1000),
              "visible": "none",
              "country": '',
              "addrName": '',
              "imageList": [],
              "secondId": ''
            },
          }
      )
      this.map.getSource('polygonLenLayer_xzt').setData(this.polygonJson_xzt.polygonLenPoint);
    },
    addPolygonToMap_xzt(val) {
      let polygon = {
        type: 'Feature',
        id: val.id,
        geometry: val.geoJson.geo.geometry,
        properties: val.geoJson.geo.properties
      }
      this.polygonJson_xzt.polygonGeo.features.push(polygon)
      this.map.getSource('polygonLayer_xzt').setData(this.polygonJson_xzt.polygonGeo);
      let polygonName = {
        type: 'Feature',
        geometry: {
          type: 'Point',
          coordinates: val.geoJson.geo.properties.center
        },
        id: val.id,
        properties: {
          "type": 'point',
          "name": val.geoJson.geo.properties.name,
          "visible": val.visible ? "visible" : "none",
          "country": "",
          "addrName": "",
          "imageList": [],
          "secondId": '',
        }
      }
      this.polygonJson_xzt.polygonNamePoint.features.push(polygonName)
      this.map.getSource('polygonNameLayer_xzt').setData(this.polygonJson_xzt.polygonNamePoint);
      if (val.geoJson.points.length !== 0) {
        this.polygonJson_xzt.polygonPoint.features.push(...val.geoJson.points)
        this.map.getSource('polygonPointLayer_xzt').setData(this.polygonJson_xzt.polygonPoint);
      }
    },
    addAreaToMap_xzt(val) {
      let area = {
        type: 'Feature',
        id: val.id,
        geometry: val.geoJson.geo.geometry,
        properties: val.geoJson.geo.properties
      }
      this.polygonJson_xzt.polygonGeo.features.push(area)
      let areaName = {
        type: 'Feature',
        geometry: {
          type: 'Point',
          coordinates: val.geoJson.geo.properties.center
        },
        id: val.id,
        properties: {
          "type": 'point',
          "name": val.geoJson.geo.properties.name,
          "visible": val.visible ? "visible" : "none",
          "country": "",
          "addrName": "",
          "imageList": [],
          "secondId": '',
        }
      }
      this.polygonJson_xzt.polygonNamePoint.features.push(areaName)
      this.map.getSource('polygonLayer_xzt').setData(this.polygonJson_xzt.polygonGeo);
      this.map.getSource('polygonNameLayer_xzt').setData(this.polygonJson_xzt.polygonNamePoint);
    },
  },
  mounted() {

  }
}
</script>

<style scoped>

</style>